import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.createStockLocationModal.title, 'Create stock location'),
  category: () => __(translations.createStockLocationModal.category, 'Category'),
  name: () => __(translations.createStockLocationModal.name, 'Name'),
  isLocked: () => __(translations.createStockLocationModal.isLocked, 'Locked'),
};
